import React, {useState} from "react";
import {Modal} from "react-bootstrap";
import {FilePond, registerPlugin} from "react-filepond";
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import Translate from "./Translate";

// Register the plugin
registerPlugin(FilePondPluginFileValidateType);

export default function ModalUploadElementi({
                                                      show,
                                                      handleClose,
                                                      translate,
                                                      token,
                                                      titolo,
                                                      endopoint,
                                                  }) {

    const [files, setFiles] = useState([])

    return (
        <Modal
            show={show}
            onHide={() => {
                handleClose()
                setFiles([])
            }}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header className={'cmms-modal-header'} closeButton>
                <Translate>{titolo}</Translate>
            </Modal.Header>

            <Modal.Body>
                <FilePond
                    files={files}
                    onupdatefiles={setFiles}
                    allowMultiple={false}
                    allowRevert={true}
                    maxFiles={1}
                    server=
                        {
                            {
                                url: endopoint,
                                process: {
                                    headers: {
                                        'jwt': token
                                    },
                                },
                                revert: (uniqueFileId, load, error) => {
                                    load(1)
                                }
                            }
                        }
                    allowSyncAcceptAttribute={true}
                    checkValidity={true}
                    dropValidation={true}
                    labelInvalidField={translate("File non valido. Sono ammessi solo file XLSX")}
                    acceptedFileTypes={['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']}
                    name="files"
                    labelIdle={translate('Trascina qui i tuoi file o') + ' <span class="filepond--label-action">' + translate('Cerca') + '</span>'}
                />
            </Modal.Body>
        </Modal>
    )

}